import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { GET_SUBSCRIPTION_FLOW_QUERY_KEY } from "./useGetSubscriptionFlow";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  subscriptionId: string;
  user: {
    name?: string;
    phoneNumber: string | null;
    mlsId?: string;
    officeName?: string;
  };
};

export const usePatchSubscriptionFlowUserInfo = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionFlowApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      // TODO: Adjust to accept undefined
      const response =
        await api.subscriptionFlowControllerPatchSubscriptionUser({
          id: params.subscriptionId,
          patchTransactionInfoRequestOmitted: {
            userName: params.user.name ?? "",
            userPhoneNumber: params.user.phoneNumber,
            userMlsId: params.user.mlsId ?? "",
            officeName: params.user.officeName ?? "",
          },
        });
      queryClient.invalidateQueries({
        queryKey: [GET_SUBSCRIPTION_FLOW_QUERY_KEY],
      });
      onSuccess?.();
      return response;
    },
    onError: (error) => {
      console.error(`Failed to save subscription flow user info`, error);
    },
  });

  return mutation;
};
